import React, { FC } from 'react';
import { Avatar } from 'components/Avatar';
import placeholder from 'assets/images/placeholder.png';

interface IComponentProps {
  userId?: string | null;
  organizationId: string | null;
  avatar?: string | null;
  name?: string | null;
  company?: string | null;
}

export const Recipient: FC<IComponentProps> = ({ userId, organizationId, avatar, name, company }) => {
  if (!userId && !organizationId) {
    return null;
  }

  return (
    <div className="recipient">
      <Avatar url={avatar ? avatar : placeholder} className="recipient__avatar" />

      <div className="recipient__container">
        {name && <span className="recipient__name">{name}</span>}

        {company && <span className="recipient__company">{company}</span>}
      </div>
    </div>
  );
};
